import useSavedViewCleaner from '@/composables/saved-views/saved-view-cleaner';
import { computed, ref } from 'vue';
import { viewApplication } from 'shared/constants.json';

export default function useCurrentView({ defaultProps, views, hasPublicViewAccess }) {
  const { clearView } = useSavedViewCleaner();

  const currentViewId = ref(0);
  const setCurrentViewId = (viewId) => {
    currentViewId.value = viewId;
  };

  const currentView = computed(() => {
    const view = views.value.find((v) => v.uid === currentViewId.value);
    if (view === undefined) {
      return {
        params: {
          filter: null,
          props: [],
          order: [],
        },
        goalSort: [],
        goalCycles: [],
        unassignedGoalCycleSelected: false,
      };
    }
    return view;
  });

  const clearedCurrentView = computed(() => clearView({
    view: currentView.value,
    props: defaultProps.value,
  }));

  const canEditCurrentView = computed(() => {
    if (!clearedCurrentView.value.isPublic) {
      return true;
    }
    return hasPublicViewAccess || ![
      viewApplication.goal,
      viewApplication.update,
      viewApplication.updateFeed,
      viewApplication.goalAccount,
      viewApplication.updateAccount,
      viewApplication.updateFeedAccount,
    ].includes(clearedCurrentView.value.viewApplication);
  });

  return {
    currentView: clearedCurrentView,
    setCurrentViewId,
    canEditCurrentView,
  };
}
